/* eslint-disable no-nested-ternary */
import * as Yup from 'yup';
import { iFormMetaData, iAttachments, iFVSCheckboxAll, iAddress, iContactMin, iSummary, iObligation } from '@interfaces/interfaces';
import { ProgressStep, FormType } from '@constants';
import { ADDRESS_FIELD_CHARS_REGEX, COMPANY_NAME_REGEX, CONTACT_NUMBER_REGEX, EMAIL_SPECIAL_CHARS_REGEX, FREE_TEXT_FIELD_REGEX, NAMES_FIELDS_REGEX, OBLIGATION_REGEX, POSITION_IN_COMPANY_REGEX, POST_CODE_REGEX, VEHICLE_REGISTRATION_REGEX } from '@services/ValidationRules';

import { FormikValues } from 'formik';
import { EMPTY_DATE, FILE_UPLOAD_FAIL, INVALID_ADDRESS_FIELD_ERROR, INVALID_ADDRESS_SEARCH_FORMAT, INVALID_COMPANY_NAME, INVALID_EMAIL, INVALID_FILE_SIZE_CUSTOM, INVALID_FREE_TEXT_FIELD_FORMAT, INVALID_FUTURE_DATE, INVALID_INPUT_LONGER_THAN_100_CHARS, INVALID_INPUT_LONGER_THAN_10_CHARS, INVALID_INPUT_LONGER_THAN_200_CHARS, INVALID_INPUT_LONGER_THAN_25_CHARS, INVALID_INPUT_LONGER_THAN_50_CHARS, INVALID_INPUT_LONGER_THAN_75_CHARS, INVALID_INPUT_LONGER_THAN_80_CHARS, INVALID_LICENCE_FORMAT, INVALID_MOBILE_NUMBER_FORMAT, INVALID_NAME_FORMAT_NEW, INVALID_NUMERIC_FORMAT, INVALID_OBLIGATION_NUMBER, INVALID_OFFENCE_FIND_OUT_DATE, INVALID_PHONE_NUMBER, INVALID_PHONE_NUMBER_LENGTH, INVALID_PHONE_NUMBER_LENGTH_15, INVALID_POSITION_IN_COMPANY_FIELD, INVALID_POST_CODE, INVALID_VEHICLE_REGISTRATION_NUMBER, INVALID_VEHICLE_REGISTRATION_NUMBER_LENGTH, INVALID_YESNO_FORMAT, MISSING_DECLARATION_AGREEMENT } from './ErrorMessages';
import keys from './PageValidationKeys';

const { INFRINGEMENTEXTENSION } = FormType;

const today = new Date();

export interface iPartialFormData {
  a: string;
  submitted: boolean;
  // Step1 Field
  OBLIGATION_NUMBER: string;
  // Step2 Fields
  OFFENCE_DATE: Date | null;
  HEARING_DATE: Date | null;
  VEHICLE_REGISTRATION: string;
  DRIVER_LICENCE: string;
  DOB: Date | null;
  // Step 3
  WasHandedInPerson: string | null;
  OFFENCE_FIND_OUT_DATE: Date | null;
  isDebtorTypeIndividual: boolean | null;
  isDebtorTypeCompany: boolean | null;
  // Step 4 fields
  SaveYesNo: string;
  SaveOptions: string;
  saveEmail: string;
  saveMobile: string;
  // Step 5
  SelectedObligationsStep5: iFVSCheckboxAll[],
  InfringementNoticeNumber: string;
  SelectedObNums: string;
  AuthorisedObligation: iObligation;
  IneligibleObligations: iObligation[];
  EligibleObligations: iObligation[];
  // Step 6
  SupportingDocuments: iAttachments[];
  DetailsForCircumstances: string;
  SupportingDocNameField: string;
  SupportingDocFilesDescription: string;
  SupportingDocFileUploadErrorHandle: boolean;
  SupportingDocUploadFileSectionError: string;
  SupportingDocFilesProvider: string;
  SupportingDocFieldErrorHandle: boolean;

  // Step 7 Individual
  IndividualFamilyName: string;
  IndividualGivenName: string;
  // Step 7 Individual License
  LicenceState: string;
  NoDriverLicence: boolean;
  StatecountryOfIssue: string;
  // Step 7 Residential Address
  IndividualResidentialAddress:iAddress;
  IndividualHasDifferentPostalAddress:string;
  IndividualPostalAddress:iAddress;
  // Step 7 Individual Contact
  IndividualContactNumber:iContactMin;
  IndividualHasNoEmail:string;
  IndividualEmail:string;
  // Step 7 Consent Questions
  IndividualEmailTo:string;
  IndividualReceiveDocs:string;
  IndividualContactNumberWarning: string
  IndividualEmailWarning: string

  // Step 7 Company
  CompanyGivenName: string;
  CompanyFamilyName: string;
  PositionInCompany: string;
  CompanyContactNumber: iContactMin;
  CompanyHasNoEmail: string;
  CompanyEmail: string;
  CompanyReceiveDocs: string;
  CompanyEmailTo: string;
  CompanyName: string;
  AbnOrAcnType: string;
  AbnNo: string;
  AcnNo: string;
  CompanyStreetAddress: iAddress;
  CompanyHasDifferentPostalAddress: string;
  CompanyPostalAddress: iAddress;
  CompanyContactNumberWarning: string;
  CompanyEmailWarning: string;

  // Step 9
  declaration: boolean;
}
interface iPartialFormObligations {
  ID: number;
  ObligationNO: string;
  IsPrimary: boolean;
}
export interface iCommonInfringementExtensionValues {
  [key: string]: string | Date | boolean | null | iFVSCheckboxAll[] | iAttachments[] | iPartialFormData | iPartialFormObligations[] | number | iAddress | iContactMin | iObligation | iObligation[];
  OBLIGATION_NUMBER: string;
  isOfficerIssued: boolean | null;
  // Step 2
  OFFENCE_DATE: Date | null;
  HEARING_DATE: Date | null;
  VEHICLE_REGISTRATION: string;
  DRIVER_LICENCE: string;
  DOB: Date | null;
  // Step 3
  WasHandedInPerson: string;
  OFFENCE_FIND_OUT_DATE: Date | null;
  isDebtorTypeIndividual: boolean | null;
  isDebtorTypeCompany: boolean | null;
  // Step 4 fields
  SaveYesNo: string;
  SaveOptions: string;
  saveEmail: string;
  saveMobile: string;
  IsSubscribedEM: boolean;
  IsSubscribedSMS: boolean;
  EMRemeinderSent: boolean;
  SMSRemeinderSent: boolean;
  // Partial Forms
  ID: string;
  PartialFormID: string;
  FormData: iPartialFormData;
  Obligations: iPartialFormObligations[];
}

export interface iInfringementExtensionFormValues extends iCommonInfringementExtensionValues {
  InfringementNumber: string;
  InfringementNoticeNumber: string;
  DebtorId: number;

  // Step 5
  SelectedObligationsStep5: iFVSCheckboxAll[],
  SelectedObNums: string;
  AuthorisedObligation: iObligation;
  IneligibleObligations: iObligation[];
  EligibleObligations: iObligation[];
  // Step 6
  SupportingDocuments: iAttachments[];
  DetailsForCircumstances: string;
  SupportingDocNameField: string;
  SupportingDocFilesDescription: string;
  SupportingDocFileUploadErrorHandle: boolean;
  SupportingDocUploadFileSectionError: string;
  SupportingDocFilesProvider: string;
  SupportingDocFieldErrorHandle: boolean;

  // Step 7 Individual
  IndividualFamilyName: string;
  IndividualGivenName: string;
  // Step 7 Individual License
  LicenceState: string;
  NoDriverLicence: boolean;
  StatecountryOfIssue: string;
  // Step 7 Residential Address
  IndividualResidentialAddress:iAddress;
  IndividualHasDifferentPostalAddress:string;
  IndividualPostalAddress:iAddress;
  // Step 7 Individual Contact
  IndividualContactNumber:iContactMin;
  IndividualHasNoEmail:string;
  IndividualEmail:string;
  // Step 7 Consent Questions
  IndividualEmailTo:string;
  IndividualReceiveDocs:string;
  IndividualContactNumberWarning: string
  IndividualEmailWarning: string

  // Step 7 Company
  CompanyGivenName: string;
  CompanyFamilyName: string;
  PositionInCompany: string;
  CompanyContactNumber: iContactMin;
  CompanyHasNoEmail: string;
  CompanyEmail: string;
  CompanyReceiveDocs: string;
  CompanyEmailTo: string;
  CompanyName: string;
  AbnOrAcnType: string;
  AbnNo: string;
  AcnNo: string;
  CompanyStreetAddress: iAddress;
  CompanyHasDifferentPostalAddress: string;
  CompanyPostalAddress: iAddress;
  CompanyContactNumberWarning: string;
  CompanyEmailWarning: string;

  // Step 9
  declaration: boolean;

  // Step 10
  submissionNo: string;
  FormExperience: string;
  // Submission Error
  // submission error message
  submissionError: string;
}

export const defaultForm = (): iInfringementExtensionFormValues => {
  const defaultValues: iInfringementExtensionFormValues = {
    OBLIGATION_NUMBER: '',
    isOfficerIssued: null,
    InfringementNumber: '',
    // Step 2
    OFFENCE_DATE: null,
    HEARING_DATE: null,
    DRIVER_LICENCE: '',
    VEHICLE_REGISTRATION: '',
    DOB: null,
    // Step 3
    WasHandedInPerson: '',
    OFFENCE_FIND_OUT_DATE: null,
    DebtorId: 0,
    isDebtorTypeIndividual: null,
    isDebtorTypeCompany: null,
    // Step 4
    SaveYesNo: '',
    SaveOptions: '',
    saveEmail: '',
    saveMobile: '',
    IsSubscribedEM: false,
    IsSubscribedSMS: false,
    EMRemeinderSent: false,
    SMSRemeinderSent: false,
    // Step 5
    AuthorisedObligation: {} as iObligation,
    InfringementNoticeNumber: '',
    SelectedObligationsStep5: [],
    SelectedObNums: '',
    EligibleObligations: [],
    IneligibleObligations: [],
    // Step 6
    SupportingDocuments: [],
    DetailsForCircumstances: '',
    SupportingDocNameField: '',
    SupportingFilesDescription: '',
    SupportingDocFileUploadErrorHandle: false,
    SupportingDocUploadFileSectionError: '',
    SupportingDocFilesProvider: '',
    SupportingDocFilesDescription: '',
    SupportingDocFieldErrorHandle: false,

    // Step 7 Individual
    IndividualFamilyName: '',
    IndividualGivenName: '',
    IndividualResidentialAddress: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    IndividualHasDifferentPostalAddress: '',
    IndividualPostalAddress: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    IndividualContactNumber: {
      ContactNumber: '',
    },

    IndividualHasNoEmail: '',
    IndividualEmail: '',
    IndividualEmailTo: '',
    IndividualReceiveDocs: '',
    LicenceState: '',
    NoDriverLicence: false,
    StatecountryOfIssue: 'Australia',
    NoFixedAddress: '',
    IndividualContactNumberWarning: '',
    IndividualEmailWarning: '',

    // Step 7 Company
    CompanyGivenName: '',
    CompanyFamilyName: '',
    PositionInCompany: '',
    CompanyContactNumber: {
      ContactNumber: '',
    },
    CompanyHasNoEmail: '',
    CompanyEmail: '',
    CompanyReceiveDocs: '',
    CompanyEmailTo: '',
    CompanyName: '',
    AbnOrAcnType: '',
    AbnNo: '',
    AcnNo: '',
    CompanyStreetAddress: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    CompanyHasDifferentPostalAddress: '',
    CompanyPostalAddress: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    CompanyContactNumberWarning: '',
    CompanyEmailWarning: '',

    // Step 9
    declaration: false,

    // Step 10
    submissionNo: '',
    FormExperience: '',
    // Submission Error
    submissionError: '',

    // Partial Forms
    ID: '',
    PartialFormID: '',
    Obligations: [],
    FormData: {
      a: '',
      // is submitted
      submitted: false,
      OBLIGATION_NUMBER: '',
      // Step 2
      OFFENCE_DATE: null,
      HEARING_DATE: null,
      VEHICLE_REGISTRATION: '',
      DRIVER_LICENCE: '',
      DOB: null,

      // Step 3
      OFFENCE_FIND_OUT_DATE: null,
      WasHandedInPerson: '',
      isDebtorTypeIndividual: null,
      isDebtorTypeCompany: null,

      // Step 4
      SaveYesNo: '',
      SaveOptions: '',
      saveEmail: '',
      saveMobile: '',

      // Step 5
      AuthorisedObligation: {} as iObligation,
      InfringementNoticeNumber: '',
      SelectedObligationsStep5: [],
      SelectedObNums: '',
      EligibleObligations: [],
      IneligibleObligations: [],
      // Step 6
      SupportingDocuments: [],
      DetailsForCircumstances: '',
      SupportingDocNameField: '',
      SupportingDocFileUploadErrorHandle: false,
      SupportingDocUploadFileSectionError: '',
      SupportingDocFilesProvider: '',
      SupportingDocFilesDescription: '',
      SupportingDocFieldErrorHandle: false,

      // Step 7 Individual
      IndividualFamilyName: '',
      IndividualGivenName: '',
      IndividualResidentialAddress: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      IndividualHasDifferentPostalAddress: '',
      IndividualPostalAddress: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      IndividualContactNumber: {
        ContactNumber: '',
      },

      IndividualHasNoEmail: '',
      IndividualEmail: '',
      IndividualEmailTo: '',
      IndividualReceiveDocs: '',
      LicenceState: '',
      NoDriverLicence: false,
      StatecountryOfIssue: 'Australia',
      IndividualContactNumberWarning: '',
      IndividualEmailWarning: '',

      // Step 7 Company
      CompanyGivenName: '',
      CompanyFamilyName: '',
      PositionInCompany: '',
      CompanyContactNumber: {
        ContactNumber: '',
      },
      CompanyHasNoEmail: '',
      CompanyEmail: '',
      CompanyReceiveDocs: '',
      CompanyEmailTo: '',
      CompanyName: '',
      AbnOrAcnType: '',
      AbnNo: '',
      AcnNo: '',
      CompanyStreetAddress: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      CompanyHasDifferentPostalAddress: '',
      CompanyPostalAddress: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      CompanyContactNumberWarning: '',
      CompanyEmailWarning: '',

    // Step 9
    declaration: false,
    }
  };
  return defaultValues;
};

export const InfringementExtensionSchema = Yup.object().shape({
  saveEmail: Yup.string().matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL).email(INVALID_EMAIL).required(INVALID_NUMERIC_FORMAT),
  saveMobile: Yup.string()
    .min(10, INVALID_MOBILE_NUMBER_FORMAT)
    .max(10, INVALID_PHONE_NUMBER_LENGTH)
    .matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER)
    .required(INVALID_PHONE_NUMBER),
  SaveYesNo: Yup.string().required(INVALID_YESNO_FORMAT),
  SaveOptions: Yup.string().when('SaveYesNo', {
    is: 'true',
    then: Yup.string().required(INVALID_NUMERIC_FORMAT),
  }),
  OBLIGATION_NUMBER: Yup.string().matches(OBLIGATION_REGEX, INVALID_OBLIGATION_NUMBER).required(INVALID_NUMERIC_FORMAT),
  OFFENCE_DATE: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  HEARING_DATE: Yup.date().required(EMPTY_DATE).nullable(),
  DRIVER_LICENCE: Yup.string()
    .required(INVALID_NUMERIC_FORMAT)
    .matches(/^[a-zA-Z0-9 ]*$/, INVALID_LICENCE_FORMAT)
    .max(25, INVALID_INPUT_LONGER_THAN_25_CHARS),
  VEHICLE_REGISTRATION: Yup.string().matches(VEHICLE_REGISTRATION_REGEX, INVALID_VEHICLE_REGISTRATION_NUMBER).max(12, INVALID_VEHICLE_REGISTRATION_NUMBER_LENGTH).required(INVALID_VEHICLE_REGISTRATION_NUMBER),
  DOB: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  OFFENCE_FIND_OUT_DATE: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE)
  .min(new Date(today.setDate(today.getDate() - 15)), INVALID_OFFENCE_FIND_OUT_DATE),
  WasHandedInPerson: Yup.string().required(INVALID_YESNO_FORMAT),

  DetailsForCircumstances: Yup.string().matches(FREE_TEXT_FIELD_REGEX, INVALID_FREE_TEXT_FIELD_FORMAT).required(INVALID_NUMERIC_FORMAT),
  FileSizeLimitSupportingDoc: Yup.string(),
  SupportingDocFieldErrorHandle: Yup.boolean().test('fileSizeTooLarge',
  function (value) {
    const { FileSizeLimitSupportingDoc } = this.parent;
    if (value === true) {
      return this.createError({
        message: INVALID_FILE_SIZE_CUSTOM(FileSizeLimitSupportingDoc)
      });
    }
    return true;
  }),
  SupportingDocFileUploadErrorHandle: Yup.boolean().oneOf([false], FILE_UPLOAD_FAIL),

  IndividualFamilyName: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  IndividualGivenName: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  StatecountryOfIssue: Yup.string(),
  LicenceState: Yup.string().required(INVALID_NUMERIC_FORMAT),
  NoDriverLicence: Yup.boolean(),
  IndividualResidentialAddress: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_SEARCH_FORMAT).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  IndividualHasDifferentPostalAddress: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  IndividualPostalAddress: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_SEARCH_FORMAT).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_POST_CODE).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  DeliveryAddressType: Yup.string().required(INVALID_YESNO_FORMAT),
  IndividualEmail: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL).max(100, INVALID_EMAIL)
    .required(INVALID_NUMERIC_FORMAT),
  IndividualHasNoEmail: Yup.boolean(),
  IndividualContactNumber: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  IndividualEmailTo: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  IndividualReceiveDocs: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),

  CompanyGivenName: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  CompanyFamilyName: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  PositionInCompany: Yup.string().matches(POSITION_IN_COMPANY_REGEX, INVALID_POSITION_IN_COMPANY_FIELD).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  CompanyContactNumber: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  CompanyHasNoEmail: Yup.boolean(),
  CompanyEmail: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL)
    .max(100, INVALID_EMAIL)
    .required(INVALID_NUMERIC_FORMAT),
  CompanyReceiveDocs: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  CompanyEmailTo: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  CompanyName: Yup.string().matches(COMPANY_NAME_REGEX, INVALID_COMPANY_NAME).max(75, INVALID_INPUT_LONGER_THAN_75_CHARS).required(INVALID_NUMERIC_FORMAT),
  AbnOrAcnType: Yup.string().required(INVALID_NUMERIC_FORMAT),
  AbnNo: Yup.string().required(INVALID_NUMERIC_FORMAT),
  AcnNo: Yup.string().required(INVALID_NUMERIC_FORMAT),
  CompanyStreetAddress: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_SEARCH_FORMAT).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_POST_CODE).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  CompanyHasDifferentPostalAddress: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  CompanyPostalAddress: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_SEARCH_FORMAT).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_POST_CODE).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  declaration: Yup.boolean().oneOf([true], MISSING_DECLARATION_AGREEMENT),
});

export const InfringementExtensionMetaData: iFormMetaData = {
  pagesSegments: {
    step0: {
      progressStep: ProgressStep.START,
      validationKeys: () => [],
    },
    step1: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, INFRINGEMENTEXTENSION).page1,
    },
    step2: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, INFRINGEMENTEXTENSION).page2,
    },
    step3: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, INFRINGEMENTEXTENSION).page3,
    },
    step4: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, INFRINGEMENTEXTENSION).page4,
    },
    step5: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, INFRINGEMENTEXTENSION).page5,
    },
    step6: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, INFRINGEMENTEXTENSION).page6,
    },
    step7: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, INFRINGEMENTEXTENSION).page7,
    },
    step8: {
      progressStep: ProgressStep.CHECK_CONFIRM,
      validationKeys: (values: FormikValues) => keys(values, INFRINGEMENTEXTENSION).page8,
    },
    step9: {
      progressStep: ProgressStep.CHECK_CONFIRM,
      validationKeys: (values: FormikValues) => keys(values, INFRINGEMENTEXTENSION).page9,
    },
    step10: {
      progressStep: ProgressStep.DONE,
      validationKeys: (values: FormikValues) => keys(values, INFRINGEMENTEXTENSION).page9,
    },
  },
};
const displayFileDetails = (attachment: iAttachments) => {
  if (attachment.FileName !== '' && attachment.FileDescription !== '') {
    return `${attachment.FileName} : ${attachment.FileDescription}`;
  }
  if (attachment.FileName !== '' && attachment.FileDescription === '') {
    return `${attachment.FileName}`;
  }
  return '';
};
const joinAddressFields = (entry: string[]) => {
  if (entry[0] === 'Address' || entry[0] === 'SearchText') return null;
  if (entry[0] === 'Country') return entry[1];
  return entry[1];
};
export const getSummaryScreen = (values: iInfringementExtensionFormValues): iSummary[] => {
  // const checkOptSupportingDoc = values.SupportingDocuments.map((attachment) => displayFileDetails(attachment))
  //   .filter(Boolean)
  //   .join('\n');

  const page3 = {
    title: 'Before you continue',
    editLink: '/step3',
    fields: [
      [
        {
          title: 'What date did you find out about the fine?',
          value: values.OFFENCE_FIND_OUT_DATE ? `${values.OFFENCE_FIND_OUT_DATE.getDate()}/${values.OFFENCE_FIND_OUT_DATE.getMonth() + 1}/${values.OFFENCE_FIND_OUT_DATE.getFullYear()}` : 'N/A'
        }
      ],
      values.isOfficerIssued
      ? [{
        title: 'Were you handed an infringement notice by an officer at the time of the offence?',
        value: values.WasHandedInPerson === 'true' ? 'Yes' : 'No'
      }] : []
    ],
  };
  const checkFines = values.SelectedObligationsStep5.map((fine) => {
    if (fine.checked) return fine.number.toString();
    return '';
  })
    .filter(Boolean)
    .join('; ');
  const page5 = {
    title: 'Your fines',
    editLink: '/step5',
    fields: [
      [{
        title: 'Fines to be included in this application',
        value: checkFines !== '' ? `${checkFines}; ${values.AuthorisedObligation.Number}` : values.AuthorisedObligation.Number,
      }],
      values.IneligibleObligations.length > 0 ? [
        {
          title: '',
          value: `You also have ${values.IneligibleObligations.length} fine(s) that is/are not eligible for an infringment extension. Please contact Fines Victoria or review our website to understand any options you may have.`
        }
      ] : []
    ]
  };
  const page6 = {
    title: 'Reason and supporting documents',
    editLink: '/step6',
    fields: [[
      {
        title: 'Tell us the reason why you only found out about your fines in the last 14 days. We will use this information to assess your application.',
        value: values.DetailsForCircumstances
      }
    ],
    [
      {
        title: 'Attachments to be included in this application',
        value: values.SupportingDocuments.length > 0 ? values.SupportingDocuments.map((attachment) => displayFileDetails(attachment))
          .filter(Boolean)
          .join('\n')
          : 'n/a',
      },
    ]
  ]
  };
  const page7 = {
    title: values.isDebtorTypeCompany ? 'Details' : 'Your details',
    editLink: '/step7',
    fields: values.isDebtorTypeCompany ? [
      [{ title: 'Given name(s)', value: values.CompanyGivenName }],
      [{ title: 'Family name', value: values.CompanyFamilyName }],
      [{ title: 'Position in company', value: values.PositionInCompany }],
      [{ title: 'Contact number', value: values.CompanyContactNumber.ContactNumber }],
      [{ title: 'Email address', value: values.CompanyHasNoEmail ? 'N/A' : values.CompanyEmail }],
      [{ title: 'Would you like to receive a copy of the completed application at the email address provided?', value: values.CompanyEmailTo === 'true' ? 'Yes' : 'No' }],
      [{ title: 'I consent to receive documentation electronically', value: values.CompanyReceiveDocs === 'true' ? 'Yes' : 'No' }],
      [{ title: 'Company name', value: values.CompanyName }],
      [{ title: 'ABN/ACN', value: values.AbnOrAcnType }],
      [{ title: 'ABN', value: values.AbnOrAcnType === 'ABN' ? values.AbnNo : 'N/A' }],
      [{ title: 'ACN', value: values.AbnOrAcnType === 'ACN' ? values.AcnNo : 'N/A' }],
      [
          {
            title: "Company's street address",
            value: `${Object.entries(values.CompanyStreetAddress)
              .map((entry) => joinAddressFields(entry))
              .filter(Boolean)
              .join(', ')}`,
          },
        ],
        values.CompanyHasDifferentPostalAddress === 'false'
      ? [{ title: 'Is the postal address different to the street address?', value: 'No' }]
      : [
          {
            title: 'Postal address',
            value: `${Object.entries(values.CompanyPostalAddress)
              .map((entry) => joinAddressFields(entry))
              .filter(Boolean)
              .join(', ')}`,
          },
        ],
    ] : [
      [{ title: 'Given name(s)', value: values.IndividualGivenName }],
      [{ title: 'Family name', value: values.IndividualFamilyName }],
      [{ title: 'Date of birth', value: values.DOB ? `${values.DOB.getDate()}/${values.DOB.getMonth() + 1}/${values.DOB.getFullYear()}` : 'n/a' }],
      [
        values.NoDriverLicence
          ? { title: 'Driver licence number', value: 'n/a' }
          : { title: 'Driver licence number', value: values.DRIVER_LICENCE ? values.DRIVER_LICENCE : 'n/a' },
      ],
      [
          values.NoDriverLicence
            ? { title: 'Place of issue', value: 'n/a' }
            : {
                title: 'Place of issue',
                value:
                  // eslint-disable-next-line no-nested-ternary
                  values.StatecountryOfIssue === 'Australia' ? (values.LicenceState ? values.LicenceState : 'n/a') : values.StatecountryOfIssue ? values.StatecountryOfIssue : 'n/a',
              },
      ],
      [
          {
            title: 'Residential address',
            value: `${Object.entries(values.IndividualResidentialAddress)
              .map((entry) => joinAddressFields(entry))
              .filter(Boolean)
              .join(', ')}`,
          },
        ],
        values.IndividualHasDifferentPostalAddress === 'false'
      ? [{ title: 'Is your residential address different to your postal address?', value: 'No' }]
      : [
          {
            title: 'Postal address',
            value: `${Object.entries(values.IndividualPostalAddress)
              .map((entry) => joinAddressFields(entry))
              .filter(Boolean)
              .join(', ')}`,
          },
        ],
        [{ title: 'Contact number', value: values.IndividualContactNumber.ContactNumber }],
        [{ title: 'Email address', value: values.IndividualHasNoEmail ? 'N/A' : values.IndividualEmail }],
      [{ title: 'Would you like to receive a copy of the completed application at the email address provided?', value: values.IndividualEmailTo === 'true' ? 'Yes' : 'No' }],
      [{ title: 'I consent to receive documentation electronically', value: values.IndividualReceiveDocs === 'true' ? 'Yes' : 'No' }],
    ]
  };
  const pagesExtensionSummary: iSummary[] = [
    page3,
    page5,
    page6,
    page7
  ];
  const summarySections: iSummary[] = pagesExtensionSummary;
  return summarySections;
};

export interface iSubmitInfringementExtensionFormValues extends iCommonInfringementExtensionValues {
  YourObligationNumber: string;
  // OBLIGATION_NUMBER: string;
  // IdentifyingReference: string;
  InfringementNoticeNumber: string;
  // Infingement Extension Step 3 Fields
  // Offence Find Out Date
  DateBecameAwareOfFine: string,
  HandedIWNoticeAtOffence: string,
  isIndividual: boolean,
  // Step 5
  ObligationNumbers: string,
  // Step 6
  NumberOfAttachments: string,
  ExplainWhyTheEnforcementOrderShouldBeReviewedProvideDetailedReasons: string,
  // Step 7
  GivenNames: string;
  FamilyNameSurname: string;
  // DD: string;
  // MM: string;
  // YYYY: string;
  DriverLicenceNumber: string;
  StateCountryOfIssue: string;
  YesEmailCorrespondence: string;
  DateOfBirth: string;

  // Residential Address
  ResidentialAddressLineOne: string;
  ResidentialAddressLineTwo: string;
  ResidentialAddressSuburb: string;
  ResidentialAddressState: string;
  ResidentialAddressPostcode: string;
  ResidentialAddressCountry: string;
  // Postal address
  PostalAddressLineOne: string;
  PostalAddressLineTwo: string;
  PostalAddressSuburb: string;
  PostalAddressState: string;
  PostalAddressPostcode: string;
  PostalAddressCountry: string;

  ContactNumber: string;
  // DocumentElectronically: string;
  EmailAddressOptional: string;

  // now time submit time
  // DdTwo: string;
  // MmTwo: string;
  // YyyyTwo: string;

  DeclarationDate: string;

  EMAIL_TO: string;
  OBLIGATIONS_TO_INCLUDE: string;
  // ATTACHMENTS: string;

  SignatureOfApplicant: string;

  FooterSubmissionNo1: string;
  FooterFormType1: string;
  FooterObligationNo1: string;
  FooterSubmittedTime1: string;

  FooterSubmissionNo2: string;
  FooterFormType2: string;
  FooterObligationNo2: string;
  FooterSubmittedTime2: string;

  // FooterSubmissionNo3: string;
  // FooterFormType3: string;
  // FooterObligationNo3: string;
  // FooterSubmittedTime3: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getReceiptPayload = (formValues: any): string => `{
  "ID": "",
  "Receipt": "",
  "Obligations": [
      {
          "ID": "",
          "ObligationNO": "${formValues.OBLIGATION_NUMBER}",
          "IsPrimary": "true",
          "ReceptNumberId": ""
      }
  ],
  "SubmittedDate": "",
  "FormTypeId": 2
}`;

export const getSubmissionPayload = (formValues: iInfringementExtensionFormValues): iSubmitInfringementExtensionFormValues => {
const submitFormValues = formValues;
const now = new Date();
const MONTH = (`0${now.getMonth() + 1}`).slice(-2);
const DATE = (`0${now.getDate()}`).slice(-2);
const YEAR = now.getFullYear();
const MINUTE = (now.getMinutes() < 10 ? '0' : '') + now.getMinutes();
const SUBMITTED_TIME = `${now.getHours()}:${MINUTE} ${DATE}/${MONTH}/${YEAR}`;
const FORM_TYPE = 'Infringement Extension';
const selectObNumbersStr = formValues.SelectedObNums?.replace(/,/g, ';');
const totalNumberOfAttachments = formValues.SupportingDocuments?.length;
const descriptionOfAttachmentsArray = [
   ...(formValues.SupportingDocuments || []),
 ];
 let remoteAttachmentNames = '';
if (descriptionOfAttachmentsArray) {
   descriptionOfAttachmentsArray.forEach((v) => {
    if (v.RemoteFileName) {
       remoteAttachmentNames += `${formValues.OBLIGATION_NUMBER}/${v.RemoteFileName}/${v.RemoteFileName}|`;
    }
  });
}
const selectedObsArray = selectObNumbersStr.split(';');
const selectedObligations = selectedObsArray.length >= 3
    ? 'Refer to attachment'
    : formValues.SelectedObNums.length !== 0
    ? `${formValues.SelectedObNums}; ${formValues.AuthorisedObligation?.Number}`
    : formValues.AuthorisedObligation?.Number;
const additonalPdfWithObligations = selectedObsArray.length >= 3 ? `${selectObNumbersStr}; ${formValues.AuthorisedObligation?.Number}` : '';
const submitObject: iSubmitInfringementExtensionFormValues = {
  ...(submitFormValues as iCommonInfringementExtensionValues),

  YourObligationNumber: formValues.OBLIGATION_NUMBER,
  InfringementNoticeNumber: formValues?.InfringementNoticeNumber,

  // Step 3
  DateBecameAwareOfFine: formValues.OFFENCE_FIND_OUT_DATE ? `${(`0${formValues.OFFENCE_FIND_OUT_DATE.getDate()}`).slice(-2)}/${(`0${formValues.OFFENCE_FIND_OUT_DATE.getMonth() + 1}`).slice(-2)}/${formValues.OFFENCE_FIND_OUT_DATE?.getFullYear()}` : '',
  HandedIWNoticeAtOffence: formValues.isOfficerIssued ? (formValues.WasHandedInPerson === 'true' ? 'Yes' : 'No') : '',
  isIndividual: !!formValues.isDebtorTypeIndividual,
  // Step 5
  ObligationNumbers: selectedObligations,
  NumberOfAttachments: totalNumberOfAttachments.toString(),
  OBLIGATIONS_TO_INCLUDE: additonalPdfWithObligations,
  ATTACHMENTS: remoteAttachmentNames,
  // Step 6
  ExplainWhyTheEnforcementOrderShouldBeReviewedProvideDetailedReasons: formValues.DetailsForCircumstances,
  // Step 7 - Individual and Company
  GivenNames: formValues.isDebtorTypeIndividual ? formValues.IndividualGivenName : formValues.CompanyGivenName,
  FamilyNameSurname: formValues.isDebtorTypeIndividual ? formValues.IndividualFamilyName : formValues.CompanyFamilyName,
  ContactNumber: formValues.isDebtorTypeIndividual ? formValues.IndividualContactNumber.ContactNumber : formValues.CompanyContactNumber.ContactNumber,
  EmailAddressOptional: formValues.isDebtorTypeIndividual ? (!formValues.IndividualHasNoEmail ? formValues.IndividualEmail : '') : (!formValues.CompanyHasNoEmail ? formValues.CompanyEmail : ''),
  // DocumentElectronically: formValues.isDebtorTypeIndividual ? (formValues.IndividualReceiveDocs === 'true' ? 'Yes' : 'No') : (formValues.CompanyReceiveDocs === 'true' ? 'Yes' : 'No'),
  EMAIL_TO: formValues.isDebtorTypeIndividual ? (formValues.IndividualEmailTo === 'true' && !formValues.IndividualHasNoEmail ? formValues.IndividualEmail : '') : (formValues.CompanyEmailTo === 'true' && !formValues.CompanyHasNoEmail ? formValues.CompanyEmail : ''),
  YesEmailCorrespondence: formValues.isDebtorTypeIndividual ? (formValues.IndividualReceiveDocs === 'true' ? 'Yes' : 'No') : (formValues.CompanyReceiveDocs === 'true' ? 'Yes' : 'No'),
  // Step 7 - Individual Fields
  DateOfBirth: formValues.DOB ? `${(`0${formValues.DOB.getDate()}`).slice(-2)}/${(`0${formValues.DOB.getMonth() + 1}`).slice(-2)}/${formValues.DOB?.getFullYear()}` : '',
  DriverLicenceNumber: formValues.NoDriverLicence ? '' : formValues.DRIVER_LICENCE,
  StateCountryOfIssue: formValues.NoDriverLicence ? '' : formValues.StatecountryOfIssue === 'Australia' ? formValues.LicenceState : formValues.StatecountryOfIssue,

  // Step 8 - Company Fields0
  CompanyName: formValues.isDebtorTypeIndividual ? '' : formValues.CompanyName,
  PositionInCompany: formValues.isDebtorTypeIndividual ? '' : formValues.PositionInCompany,
  // eslint-disable-next-line no-nested-ternary
  ABNACN: formValues.isDebtorTypeIndividual ? '' : (formValues.AbnOrAcnType === 'ABN' ? formValues.AbnNo : formValues.AcnNo),

  // Individual Residential Address or Company Street Address
  ResidentialAddressLineOne: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.LineOne : formValues.CompanyStreetAddress.LineOne,
  ResidentialAddressLineTwo: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.LineTwo : formValues.CompanyStreetAddress.LineTwo,
  ResidentialAddressPostcode: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.Postcode : formValues.CompanyStreetAddress.Postcode,
  ResidentialAddressState: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.State : formValues.CompanyStreetAddress.State,
  ResidentialAddressSuburb: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.Suburb : formValues.CompanyStreetAddress.Suburb,
  ResidentialAddressCountry: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.Country : formValues.CompanyStreetAddress.Country,

  StreetAddressLineOne: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.LineOne : formValues.CompanyStreetAddress.LineOne,
  StreetAddressLineTwo: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.LineTwo : formValues.CompanyStreetAddress.LineTwo,
  StreetAddressPostcode: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.Postcode : formValues.CompanyStreetAddress.Postcode,
  StreetAddressState: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.State : formValues.CompanyStreetAddress.State,
  StreetAddressSuburb: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.Suburb : formValues.CompanyStreetAddress.Suburb,
  StreetAddressCountry: formValues.isDebtorTypeIndividual ? formValues.IndividualResidentialAddress.Country : formValues.CompanyStreetAddress.Country,
  // Indivual or Company Postal Address
  PostalAddressLineOne: formValues.isDebtorTypeIndividual
    ? (formValues.IndividualHasDifferentPostalAddress === 'true' ? formValues.IndividualPostalAddress.LineOne : formValues.IndividualResidentialAddress.LineOne)
    : (formValues.CompanyHasDifferentPostalAddress === 'true' ? formValues.CompanyPostalAddress.LineOne : formValues.CompanyStreetAddress.LineOne),
  PostalAddressLineTwo: formValues.isDebtorTypeIndividual
    ? (formValues.IndividualHasDifferentPostalAddress === 'true' ? formValues.IndividualPostalAddress.LineTwo : formValues.IndividualResidentialAddress.LineTwo)
    : (formValues.CompanyHasDifferentPostalAddress === 'true' ? formValues.CompanyPostalAddress.LineTwo : formValues.CompanyStreetAddress.LineTwo),
  PostalAddressPostcode: formValues.isDebtorTypeIndividual
    ? (formValues.IndividualHasDifferentPostalAddress === 'true' ? formValues.IndividualPostalAddress.Postcode : formValues.IndividualResidentialAddress.Postcode)
    : (formValues.CompanyHasDifferentPostalAddress === 'true' ? formValues.CompanyPostalAddress.Postcode : formValues.CompanyStreetAddress.Postcode),
  PostalAddressState: formValues.isDebtorTypeIndividual
    ? (formValues.IndividualHasDifferentPostalAddress === 'true' ? formValues.IndividualPostalAddress.State : formValues.IndividualResidentialAddress.State)
    : (formValues.CompanyHasDifferentPostalAddress === 'true' ? formValues.CompanyPostalAddress.State : formValues.CompanyStreetAddress.State),
  PostalAddressSuburb: formValues.isDebtorTypeIndividual
    ? (formValues.IndividualHasDifferentPostalAddress === 'true' ? formValues.IndividualPostalAddress.Suburb : formValues.IndividualResidentialAddress.Suburb)
    : (formValues.CompanyHasDifferentPostalAddress === 'true' ? formValues.CompanyPostalAddress.Suburb : formValues.CompanyStreetAddress.Suburb),
  PostalAddressCountry: formValues.isDebtorTypeIndividual
    ? (formValues.IndividualHasDifferentPostalAddress === 'true' ? formValues.IndividualPostalAddress.Country : formValues.IndividualResidentialAddress.Country)
    : (formValues.CompanyHasDifferentPostalAddress === 'true' ? formValues.CompanyPostalAddress.Country : formValues.CompanyStreetAddress.Country),

  SignatureOfApplicant: formValues.declaration ? 'I agree to the statements' : '',

  DeclarationDate: `${DATE}/${MONTH}/${YEAR}`,

  // Footer information
  FooterSubmissionNo: '2342',
  FooterFormType: FORM_TYPE,
  FooterObligationNo: formValues.OBLIGATION_NUMBER,
  FooterSubmittedTime: SUBMITTED_TIME,

  FooterSubmissionNo1: '2342',
  FooterFormType1: FORM_TYPE,
  FooterObligationNo1: formValues.OBLIGATION_NUMBER,
  FooterSubmittedTime1: SUBMITTED_TIME,

  FooterSubmissionNo2: '234',
  FooterFormType2: FORM_TYPE,
  FooterObligationNo2: formValues.OBLIGATION_NUMBER,
  FooterSubmittedTime2: SUBMITTED_TIME,

};

const excludeKeysFromForm: string[] = [
  'ABNACNNo',
  'AbnNo',
  'AbnOrAcnType',
  'AcnNo',
  'Attachments',
  'AuthorisedObligation',
  'CompanyContactNumber',
  'CompanyGivenName',
  'CompanyEmail',
  'CompanyEmailTo',
  'CompanyEmailTo',
  'CompanyFamilyName',
  'CompanyGivenName',
  'CompanyHasDifferentPostalAddress',
  'CompanyHasNoEmail',
  'CompanyPostalAddress',
  'CompanyReceiveDocs',
  'CompanyStreetAddress',
  'CountryTwo',
  'DOB',
  'DOBRequired',
  'DRIVER_LICENCE',
  'DebtorID',
  'DebtorId',
  'DebtorType',
  'EligibleObligations',
  'ExpiryDate',
  'FormData',
  'SelectedObNums',
  'FormExperience',
  'FormTypeID',
  'HEARING_DATE',
  'HearingDateRequired',
  'ID',
  'IdentifyingReference',
  'IndividualContactNumber',
  'IndividualEmail',
  'IndividualEmailTo',
  'IndividualFamilyName',
  'IndividualGivenName',
  'IndividualHasDifferentPostalAddress',
  'IndividualHasNoEmail',
  'IndividualPostalAddress',
  'IndividualResidentialAddress',
  'IneligibleObligations',
  'LicenceRequired',
  'LicenceState',
  'NoDriverLicence',
  'NoFixedAddress',
  'NumberAttachments',
  'OFFENCE_DATE',
  'OFFENCE_FIND_OUT_DATE',
  'ObligationStatus',
  'Obligations',
  'OffenceCode',
  'OffenceDateRequired',
  'PartialFormID',
  'RegistrationRequired',
  'SaveOptions',
  'SaveYesNo',
  'SelectedObligations',
  'SelectedObligationsStep5',
  'StatecountryOfIssue',
  'Status',
  'SupportingDocFieldErrorHandle',
  'SupportingDocFileUploadErrorHandle',
  'SupportingDocFilesDescription',
  'SupportingDocFilesProvider',
  'SupportingDocNameField',
  'SupportingDocUploadFileSectionError',
  'SupportingDocuments',
  'SupportingFilesDescription',
  'TicketType',
  'declaration',
  'isDebtorTypeCompany',
  'isDebtorTypeIndividual',
  'isOfficerIssued',
  'saveEmail',
  'saveMobile',
  'submissionError',
  'submissionNo',
  'submitted',
  'CreateDate',
  'IsSubscribedEM',
  'IsSubscribedSMS',
  'EMRemeinderSent',
  'SMSRemeinderSent',
  'DetailsForCircumstances',
  'IndividualContactNumberWarning',
  'IndividualEmailWarning',
  'CompanyContactNumberWarning',
  'CompanyEmailWarning',
];
excludeKeysFromForm.forEach((value: string) => {
  delete submitObject[value];
});
return submitObject;
};
